<script>
    import { getContext } from "svelte"
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import YupPassword from 'yup-password';
    YupPassword(yup);
    import {
        Alert,
        FormGroup,
        Label,
        Input,
        Container,
        Row,
        Col
    } from 'sveltestrap';
    
    import Text from "./Fields/Text.svelte";
    import Email from "./Fields/Email.svelte";
	import Password from "./Fields/Password.svelte";
	import DatePicker from "./Fields/DatePicker.svelte";
    import Recaptcha from "./Fields/Recaptcha.svelte";

    import { _ } from "svelte-i18n";

    import { connected, city } from "../../store";
    import { set_autocomplete } from "../../autocomplete.js";

    let apiUrl = getContext("apiUrl");

    let result = null;

    let today  = new Date;
    let todayMonth = today.getMonth() + 1;
    let todayDay = today.getUTCDate();

    if(todayMonth < 10)
        todayMonth = "0" + todayMonth;

    if (todayDay < 10)
        todayDay = "0" + todayDay;

    let todayFormat = "-" + todayMonth + "-" + todayDay;

    let eighteenYearsAgo = today.getFullYear()-18  + todayFormat;
    let ninetynineYearsAgo = today.getFullYear()-99 + todayFormat;

    let gender;
    let interested;

    const { form, errors, handleChange, handleSubmit, isValid } = createForm({
        initialValues: {
            name: "",
            registerEmail: "",
            registerPassword: "",
            confirmPassword: "",
            birthdate: eighteenYearsAgo,
            gender: "",
            interested: "",
            cgu: ""
        },
        validationSchema: yup.object().shape({
            name: yup
                .string($_("components.Forms.errorMessage.string"))
                .min(3, $_("components.Forms.errorMessage.min"))
                .max(20, $_("components.Forms.errorMessage.max"))
                .required($_("components.Forms.errorMessage.required")),
            registerEmail: yup
                .string($_("components.Forms.errorMessage.string"))
                .email($_("components.Forms.errorMessage.email"))
                .required($_("components.Forms.errorMessage.required")),
            registerPassword: yup
                .string($_("components.Forms.errorMessage.string"))
                //.matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, errorMessage.passwordContains)
                .password()
                .minLowercase(3, $_("components.Forms.errorMessage.password.minLowerCase"))
                .minUppercase(1,  $_("components.Forms.errorMessage.password.minUpperCase"))
                .minNumbers(1, $_("components.Forms.errorMessage.password.minNumbers"))
                .minSymbols(1, $_("components.Forms.errorMessage.password.minSymbols"))
                .minRepeating(3)
                .min(8, $_("components.Forms.errorMessage.min", {min:"8"}))
                .required($_("components.Forms.errorMessage.required")),
            confirmPassword: yup
                .string()
                .required($_("components.Forms.errorMessage.required"))
                .oneOf([yup.ref('registerPassword')], $_("components.Forms.errorMessage.password.notMatches")),
            birthDate: yup
                .date()
                .min(ninetynineYearsAgo, $_("components.Forms.errorMessage.dateMin"))
                .max(eighteenYearsAgo, $_("components.Forms.errorMessage.dateMax")),
            gender: yup
                .string()
                .oneOf(["F", "M"], $_("components.Forms.errorMessage.oneOfMF"))
                .required($_("components.Forms.errorMessage.required")),
            interested: yup
                .string()
                .oneOf(["F", "M"], $_("components.Forms.errorMessage.oneOfMF"))
                .required($_("components.Forms.errorMessage.required")),
            cgu: yup.bool().required($_("components.Forms.errorMessage.required"))
        }),
        onSubmit: async () => {
            var Form = new FormData(document.getElementById("registerForm"))
            const res = await fetch(apiUrl + 'register.php', {
                method: 'POST',
                body: Form
            })
            
            const json = await res.json()
            result = json;

            if(result.success) {
                $connected = true;
                setTimeout(() => { location.reload(); }, 1500);
            }
        }
    });

    async function autocomplete(){
        let input = document.getElementById("City");

        const res = await fetch(apiUrl + "fetchCities.php?search="+encodeURI(input.value));
        const result = await res.json();

        console.log(result)
        
        let country_list = result;
        set_autocomplete('City', 'city_complete', country_list);
    }
</script>

{#key result}
    {#if result}
        {#if result.error}
            <Alert color="danger" dismissible>{result.error}</Alert>
        {/if}
        {#if result.success}
            <Alert color="success" dismissible>{result.success}</Alert>
        {/if}
    {/if}
{/key}

{#if $form.name}
    <div class="container pt-3">
        <h4 class="text-center"><u>{$_("components.Forms.RegisterForm.welcome")} <b>{$form.name}</b> !</u></h4>
    </div>
{/if}

<form on:submit|preventDefault={handleSubmit} id="registerForm" class="needs-validation" novalidate>
    <Text
        name="name"
        autocomplete="given-name"
        label={$_("components.Forms.RegisterForm.firstName")}
        feedback={$errors.name}
        bind:value={$form.name}
        on:change={handleChange}
        on:blur={handleChange}
        minlength="3"
        maxlength="20"
        required
    />
    <Email 
        name="registerEmail"
        autocomplete="email"
        label={$_("components.Forms.RegisterForm.email")}
        feedback={$errors.registerEmail}
        bind:value={$form.registerEmail}
        on:change={handleChange}
        on:blur={handleChange}
    />
    <Password 
        name="registerPassword"
        autocomplete="new-password"
        label={$_("components.Forms.RegisterForm.newPassword")}
        feedback={$errors.registerPassword}
        bind:value={$form.registerPassword}
        on:change={handleChange}
        on:blur={handleChange}
    />
    <Password 
        name="confirmPassword"
        autocomplete="new-password"
        label={$_("components.Forms.RegisterForm.confirmNewPassword")}
        feedback={$errors.confirmPassword}
        bind:value={$form.confirmPassword}
        on:change={handleChange}
        on:blur={handleChange}
    />
    <DatePicker 
        name="birthDate"
        autocomplete="bday"
        label={$_("components.Forms.RegisterForm.birthdate")}
        feedback={$errors.birthDate}
        bind:value={$form.birthDate}
        on:change={handleChange}
        on:blur={handleChange}
        min={ninetynineYearsAgo}
        max={eighteenYearsAgo}
    />
    <FormGroup>
        <Label for="City">{$_("components.Forms.RegisterForm.postalCode")} :</Label>
        <Input
            name="City"
            id="City"
            type="text"
            autocomplete="off"
            on:keyup={autocomplete}
            value={$city}
            required
        />
        <div class="position-absolute invisible" id="city_complete"></div>
    </FormGroup>
    <FormGroup>
        <Label for="gender">{$_("components.Forms.RegisterForm.gender")} :</Label>
        <Container>
            <Row>
                <Col lg="3"></Col>
                <Col lg="3" md="6" sm="6" xs="6">
                    {#if $errors.gender}
                        <Input
                            name="gender"
                            id="FGender"
                            type="radio"
                            bind:checked={$form.gender}
                            bind:group={gender}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="F"
                            label="Femme"
                            invalid
                        />
                    {:else}
                        <Input
                            name="gender"
                            id="FGender"
                            type="radio"
                            bind:checked={$form.gender}
                            bind:group={gender}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="F"
                            label="Femme"
                        />
                    {/if}
                </Col>
                <Col lg="3" md="6" sm="6" xs="6">
                    {#if $errors.gender}
                        <Input
                            name="gender"
                            id="MGender"
                            type="radio"
                            bind:checked={$form.gender}
                            bind:group={gender}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="M"
                            label="Homme"
                            invalid
                        />
                    {:else}
                        <Input
                            name="gender"
                            id="MGender"
                            type="radio"
                            bind:checked={$form.gender}
                            bind:group={gender}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="M"
                            label="Homme"
                        />
                    {/if}
                </Col>
                <Col lg="3"></Col>
                {#if $errors.gender}
                    <Col lg="12" md="12" sm="12" xs="12" class="text-center text-danger">
                        {$errors.gender}
                    </Col>
                {/if}
            </Row>
        </Container>
    </FormGroup>
    <FormGroup>
        <Label for="interested">{$_("components.Forms.RegisterForm.interestedIn")} :</Label>
        <Container>
            <Row>
                <Col lg="3"></Col>
                <Col lg="3" md="6" sm="6" xs="6">
                    {#if $errors.interested}
                        <Input
                            name="interested"
                            id="Finterested"
                            type="radio"
                            bind:checked={$form.interested}
                            bind:group={interested}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="F"
                            label="Femme"
                            invalid
                        />
                    {:else}
                        <Input
                            name="interested"
                            id="Finterested"
                            type="radio"
                            bind:checked={$form.interested}
                            bind:group={interested}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="F"
                            label="Femme"
                        />
                    {/if}
                </Col>
                <Col lg="3" md="6" sm="6" xs="6">
                    {#if $errors.interested}
                        <Input
                            name="interested"
                            id="Minterested"
                            type="radio"
                            bind:checked={$form.interested}
                            bind:group={interested}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="M"
                            label="Homme"
                            invalid
                        />
                    {:else}
                        <Input
                            name="interested"
                            id="Minterested"
                            type="radio"
                            bind:checked={$form.interested}
                            bind:group={interested}
                            on:change={handleChange}
                            on:blur={handleChange}
                            value="M"
                            label="Homme"
                        />
                    {/if}
                </Col>
                <Col lg="3"></Col>
                {#if $errors.interested}
                    <Col lg="12" md="12" sm="12" xs="12" class="text-center text-danger">
                        {$errors.interested}
                    </Col>
                {/if}
            </Row>
        </Container>
    </FormGroup>
    <Recaptcha />
    <FormGroup>
        <Input
            type="checkbox"
            name="cgu"
            id="cgu"
            value="true"
            bind:checked={$form.cgu}
            on:change={handleChange}
            on:blur={handleChange}
            label="{$_("components.Forms.RegisterForm.cgu")}"
            required
        />
    </FormGroup>
    <div class="d-grid gap-2">
        <input type="submit" class="btn btn-primary" disabled={!$isValid} value="{$_("components.Forms.RegisterForm.register")}" />
    </div>
</form>